// extracted by mini-css-extract-plugin
export default {"uploadDocumentWrapper":"UploadIndicatorDocumentOrganism_uploadDocumentWrapper__22oaP"};